import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const RefundSummaryReport: React.FC = () => (
  <ReportPageShell
    reportType="refund-summary"
    title="Refund Summary"
    subtitle="Refund transactions grouped by the user who processed them. Returned as a positive magnitude — the SUM reconciles to the Sales Summary refunds value."
    maxRangeDays={366}
    bullets={[
      'User Login',
      'User Name',
      'Refund Count',
      'Refund Total',
    ]}
  />
);

export default RefundSummaryReport;
